export { colors } from './data/colors'
